export const DEFAULT_AI_MODEL_NAME = 'gemini-2.5-flash';

export const DEFAULT_AI_GENERATION_CONFIG = {
  temperature: 0.5,
  maxOutputTokens: 8192,
  topP: 0.95,
};

export const AI_RESPONSE_LIMITS = {
  maxPortfolioItems: 24,
  maxRecommendations: 10,
  maxChecklistFeedback: 25,
  maxImagesToDescribe: 10, // Limit images processed for description per call
};
